import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

import { CustomButton } from "../../../shared/uiComponents";
import { errorNormalizer } from "../../../shared/Helpers/functions";
import { downloadFile, ReportFilters, TimeInputsWrapper } from "../helpers";
import UploadAssessmentReport from "./uploadReport";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { getAssessmentReport } from "../../../redux/State/clientSlice/excelReport";

const AssessmentReport = () => {
  const dispatch = useDispatch<DispatchProperties>();

  const filterData = useSelector((state) => state.billing.billingFilters);
  const loading = useSelector((state) => state.excelReport.loading);

  const downloadHandler = useCallback(() => {
    const { clientId, endDate, startDate } = filterData;

    dispatch(
      getAssessmentReport({
        clientId,
        startDate,
        endDate,
      })
    )
      .then(unwrapResult)
      .then((response) => downloadFile(response))
      .catch(errorNormalizer);
  }, [dispatch, filterData]);

  return (
    <>
      <ReportFilters showUsers={false} showOnlyNew={false} />
      <TimeInputsWrapper>
        <CustomButton
          title="Download"
          onClick={downloadHandler}
          loading={loading}
          disabled={filterData.timeError || !filterData.clientId}
        />
        <UploadAssessmentReport />
      </TimeInputsWrapper>
    </>
  );
};

export default AssessmentReport;
